var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSidebarEditProfileIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_264_8575)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.1289 8.08364L8.70487 12.3443C8.38756 12.6499 8.17142 13.0443 8.08524 13.4751L7.85939 14.6041C7.78283 14.9868 8.12704 15.3215 8.51024 15.237L9.65473 14.9846C10.0711 14.8928 10.451 14.6813 10.7474 14.3764L15.0287 9.97218C15.4052 9.59795 15.2907 8.87566 14.7722 8.35413C14.2477 7.82651 13.5098 7.70505 13.1289 8.08364Z",
    stroke: "#424242",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.75 15.25C0.75 11.8661 4.12944 8.96566 7.50888 9.93248",
    stroke: "#424242",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.32129 4.06991C3.32129 2.23648 4.81193 0.750165 6.65071 0.750165C8.48949 0.750165 9.98013 2.23648 9.98013 4.06991C9.98013 5.90334 8.48949 7.38965 6.65071 7.38965C4.81193 7.38965 3.32129 5.90334 3.32129 4.06991Z",
    stroke: "#424242",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_264_8575"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSidebarEditProfileIcon);
export default __webpack_public_path__ + "static/media/sidebar-edit-profile-icon.f166d2bc9451df14bc1190c95989f0fd.svg";
export { ForwardRef as ReactComponent };